import React from 'react';
import ElectricalServicesComp from "../components/ElectricServicesPage/ElectricalServicesComp";

const ElectricalService = () => {
    return (
        <ElectricalServicesComp/>
    );
};

export default ElectricalService;